import { render, staticRenderFns } from "./addOptions.bak.vue?vue&type=template&id=313b53f2&scoped=true"
import script from "./addOptions.bak.vue?vue&type=script&lang=js"
export * from "./addOptions.bak.vue?vue&type=script&lang=js"
import style0 from "./addOptions.bak.vue?vue&type=style&index=0&id=313b53f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b53f2",
  null
  
)

export default component.exports